"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = __importDefault(require("lodash"));
const API = {
    list: `/api/ac/v2/runtimeconfig/published/list`,
    detail: (configKey) => `/api/ac/v2/runtimeconfig/published/detail?key=${configKey}`,
    listMicroHost: `/api/ac/v2/runtimeconfig/published/micro/hosts`,
};
class RunTimeConfigAPI {
    constructor(httpClient) {
        this._httpClient = httpClient;
    }
    async getConfigList(key = [], options = { select: [], page: 0, limit: 10 }) {
        const data = {
            result: null,
            entities: {},
            paging: {},
        };
        const res = await this._httpClient.get(API.list, {
            params: {
                key,
                select: options.select,
                page: options.page,
                limit: options.limit,
            },
        });
        const resBody = lodash_1.default.get(res, 'data.data', null);
        if (!resBody) {
            return data;
        }
        data.result = resBody.result;
        data.entities = resBody.entities;
        data.paging = resBody.paging;
        return data;
    }
    async getConfigDetail(configKey) {
        const data = {
            result: null,
            entities: {},
        };
        const res = await this._httpClient.get(API.detail(configKey), {});
        if (!res.data || !res.data.data) {
            return data;
        }
        const resBody = res.data.data;
        data.result = resBody.result;
        data.entities = resBody.entities;
        return data;
    }
    async getListMicroFrontendHost() {
        const data = {
            result: null,
            entities: {},
        };
        const res = await this._httpClient.get(API.listMicroHost);
        if (!res.data || !res.data.data) {
            return data;
        }
        const resBody = res.data.data;
        data.result = resBody.result;
        data.entities = resBody.entities;
        return resBody;
    }
}
exports.default = RunTimeConfigAPI;
